module.exports = __webpack_public_path__ + "static/vuls-logo-large-4f25ed997a36c1a3a64c832834d583ec.png";